
import { PrimaryText } from '../../components';
import { emptyHelpForType } from '../../fleet-shared/LogbookTypes.mjs';

// Help text displayed when a logbook is empty. Used in a couple of places, so
// made into a component.
//
// The wording is the TYPE's (LogbookTypes.mjs `emptyHelp`), not this file's: a
// Captain's Log records trips and a Pilot's Logbook records flights, and only
// Maintenance can gain an entry by completing a task -- the same gate
// PickLogbookAddType already applies to its "Select from Tasks List" button.
// `typeId` may be omitted; emptyHelpForType falls back to Maintenance for
// unknown / missing ids like every other accessor there.
export const LogbookHelp = ({ typeId }) => {
    const { what, how } = emptyHelpForType(typeId);

    return (
        <PrimaryText>
            <b>
                <p>{what}</p>
                <p>{how}</p>
            </b>
        </PrimaryText>
    );
}
